export default __webpack_public_path__ + "static/media/katika-logo_wht.7c297ad6.svg";